module.exports = {
	"name": "DMN",
	"uri": "http://www.omg.org/spec/DMN/20151101/dmn.xsd",
	"xml": {
		"tagAlias": "lowerCase"
	},
	"prefix": "dmn",
	"types": [
		{
			"name": "DMNElement",
			"isAbstract": true,
			"properties": [
				{
					"name": "description",
					"type": "String"
				},
				{
					"name": "id",
					"type": "String",
					"isAttr": true,
					"isId": true
				},
				{
					"name": "label",
					"type": "String",
					"isAttr": true
				},
				{
					"name": "extensionElements",
					"type": "ExtensionElements"
				}
			]
		},
		{
			"name": "NamedElement",
			"isAbstract": true,
			"superClass": [
				"DMNElement"
			],
			"properties": [
				{
					"name": "name",
					"type": "String",
					"isAttr": true
				}
			]
		},
		{
			"name": "DMNElementReference",
			"properties": [
				{
					"name": "href",
					"type": "String",
					"isAttr": true
				}
			]
		},
		{
			"name": "ExtensionElements",
			"properties": [
				{
					"name": "values",
					"type": "Element",
					"isMany": true
				}
			]
		},
		{
			"name": "Definitions",
			"superClass": [
				"NamedElement"
			],
			"properties": [
				{
					"name": "namespace",
					"type": "String",
					"isAttr": true
				},
				{
					"name": "typeLanguage",
					"type": "String",
					"isAttr": true,
					"default": "http://www.omg.org/spec/FEEL/20140401"
				},
				{
					"name": "expressionLanguage",
					"type": "String",
					"isAttr": true,
					"default": "http://www.omg.org/spec/FEEL/20140401"
				},
				{
					"name": "exporter",
					"type": "String",
					"isAttr": true
				},
				{
					"name": "exporterVersion",
					"type": "String",
					"isAttr": true
				},
				{
					"name": "itemDefinition",
					"type": "ItemDefinition",
					"isMany": true,
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "drgElements",
					"type": "DRGElement",
					"isMany": true
				},
				{
					"name": "artifacts",
					"type": "Artifact",
					"isMany": true
				}
			]
		},
		{
			"name": "Import",
			"properties": [
				{
					"name": "namespace",
					"type": "String",
					"isAttr": true
				},
				{
					"name": "locationURI",
					"type": "String",
					"isAttr": true
				},
				{
					"name": "importType",
					"type": "String",
					"isAttr": true
				}
			]
		},
		{
			"name": "DRGElement",
			"isAbstract": true,
			"superClass": [
				"NamedElement"
			]
		},
		{
			"name": "Decision",
			"superClass": [
				"DRGElement"
			],
			"properties": [
				{
					"name": "question",
					"type": "String"
				},
				{
					"name": "allowedAnswers",
					"type": "String"
				},
				{
					"name": "variable",
					"type": "InformationItem",
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "informationRequirement",
					"type": "InformationRequirement",
					"isMany": true,
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "knowledgeRequirement",
					"type": "KnowledgeRequirement",
					"isMany": true,
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "authorityRequirement",
					"type": "AuthorityRequirement",
					"isMany": true,
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "decisionTable",
					"type": "DecisionTable",
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "literalExpression",
					"type": "LiteralExpression",
					"xml": {
						"serialize": "property"
					}
				}
			]
		},
		{
			"name": "BusinessKnowledgeModel",
			"superClass": [
				"DRGElement"
			],
			"properties": [
				{
					"name": "encapsulatedLogic",
					"type": "FunctionDefinition"
				},
				{
					"name": "variable",
					"type": "InformationItem",
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "knowledgeRequirement",
					"type": "KnowledgeRequirement",
					"isMany": true,
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "authorityRequirement",
					"type": "AuthorityRequirement",
					"isMany": true,
					"xml": {
						"serialize": "property"
					}
				}
			]
		},
		{
			"name": "InputData",
			"superClass": [
				"DRGElement"
			],
			"properties": [
				{
					"name": "variable",
					"type": "InformationItem",
					"xml": {
						"serialize": "property"
					}
				}
			]
		},
		{
			"name": "KnowledgeSource",
			"superClass": [
				"DRGElement"
			],
			"properties": [
				{
					"name": "authorityRequirement",
					"type": "AuthorityRequirement",
					"isMany": true,
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "type",
					"type": "String",
					"isAttr": true
				},
				{
					"name": "owner",
					"type": "DMNElementReference",
					"isAttr": true
				},
				{
					"name": "locationURI",
					"type": "String",
					"isAttr": true
				}
			]
		},
		{
			"name": "InformationRequirement",
			"properties": [
				{
					"name": "requiredDecision",
					"type": "DMNElementReference",
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "requiredInput",
					"type": "DMNElementReference",
					"xml": {
						"serialize": "property"
					}
				}
			]
		},
		{
			"name": "KnowledgeRequirement",
			"properties": [
				{
					"name": "requiredKnowledge",
					"type": "DMNElementReference",
					"isUnique": true,
					"xml": {
						"serialize": "property"
					}
				}
			]
		},
		{
			"name": "AuthorityRequirement",
			"properties": [
				{
					"name": "requiredDecision",
					"type": "DMNElementReference",
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "requiredInput",
					"type": "DMNElementReference",
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "requiredAuthority",
					"type": "DMNElementReference",
					"xml": {
						"serialize": "property"
					}
				}
			]
		},
		{
			"name": "Expression",
			"isAbstract": true,
			"superClass": [
				"DMNElement"
			],
			"properties": [
				{
					"name": "typeRef",
					"type": "String",
					"isAttr": true
				}
			]
		},
		{
			"name": "ItemDefinition",
			"superClass": [
				"NamedElement"
			],
			"properties": [
				{
					"name": "typeLanguage",
					"type": "String",
					"isAttr": true
				},
				{
					"name": "isCollection",
					"type": "Boolean",
					"isAttr": true,
					"default": false
				},
				{
					"name": "typeRef",
					"type": "String"
				},
				{
					"name": "allowedValues",
					"type": "UnaryTests",
					"isMany": true,
					"xml": {
						"serialize": "property"
					}
				}
			]
		},
		{
			"name": "LiteralExpression",
			"superClass": [
				"Expression"
			],
			"properties": [
				{
					"name": "expressionLanguage",
					"type": "String",
					"isAttr": true
				},
				{
					"name": "importedValues",
					"type": "ImportedValues"
				},
				{
					"name": "text",
					"type": "String"
				}
			]
		},
		{
			"name": "InformationItem",
			"superClass": [
				"NamedElement"
			],
			"properties": [
				{
					"name": "typeRef",
					"type": "String",
					"isAttr": true
				}
			]
		},
		{
			"name": "DecisionTable",
			"superClass": [
				"Expression"
			],
			"properties": [
				{
					"name": "input",
					"type": "InputClause",
					"isMany": true,
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "output",
					"type": "OutputClause",
					"isMany": true,
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "rule",
					"type": "DecisionRule",
					"isMany": true,
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "hitPolicy",
					"type": "HitPolicy",
					"isAttr": true,
					"default": "UNIQUE"
				},
				{
					"name": "aggregation",
					"type": "BuiltinAggregator",
					"isAttr": true
				},
				{
					"name": "preferredOrientation",
					"type": "DecisionTableOrientation",
					"isAttr": true,
					"default": "Rule-as-Row"
				},
				{
					"name": "outputLabel",
					"type": "String",
					"isAttr": true
				}
			]
		},
		{
			"name": "DecisionRule",
			"superClass": [
				"DMNElement"
			],
			"properties": [
				{
					"name": "inputEntry",
					"type": "UnaryTests",
					"isMany": true,
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "outputEntry",
					"type": "LiteralExpression",
					"isMany": true,
					"xml": {
						"serialize": "property"
					}
				}
			]
		},
		{
			"name": "ImportedValues",
			"superClass": [
				"Import"
			],
			"properties": [
				{
					"name": "importedElement",
					"type": "String",
					"isMany": true,
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "expressionLanguage",
					"type": "String",
					"isAttr": true
				}
			]
		},
		{
			"name": "Artifact",
			"isAbstract": true,
			"superClass": [
				"DMNElement"
			]
		},
		{
			"name": "TextAnnotation",
			"superClass": [
				"Artifact"
			],
			"properties": [
				{
					"name": "text",
					"type": "String",
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "textFormat",
					"type": "String",
					"isAttr": true
				}
			]
		},
		{
			"name": "Association",
			"superClass": [
				"Artifact"
			],
			"properties": [
				{
					"name": "sourceRef",
					"type": "DMNElementReference",
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "targetRef",
					"type": "DMNElementReference",
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "associationDirection",
					"type": "AssociationDirection",
					"isAttr": true,
					"default": "None"
				}
			]
		},
		{
			"name": "InputClause",
			"superClass": [
				"DMNElement"
			],
			"properties": [
				{
					"name": "inputExpression",
					"type": "LiteralExpression",
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "inputValues",
					"type": "UnaryTests",
					"xml": {
						"serialize": "property"
					}
				}
			]
		},
		{
			"name": "OutputClause",
			"superClass": [
				"DMNElement"
			],
			"properties": [
				{
					"name": "outputValues",
					"type": "UnaryTests",
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "defaultOutputEntry",
					"type": "LiteralExpression",
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "name",
					"type": "String",
					"isAttr": true
				},
				{
					"name": "typeRef",
					"type": "String",
					"isAttr": true
				}
			]
		},
		{
			"name": "UnaryTests",
			"superClass": [
				"DMNElement"
			],
			"properties": [
				{
					"name": "text",
					"type": "String"
				},
				{
					"name": "expressionLanguage",
					"type": "String",
					"isAttr": true
				}
			]
		},
		{
			"name": "FunctionDefinition",
			"superClass": [
				"Expression"
			],
			"properties": [
				{
					"name": "formalParameter",
					"type": "InformationItem",
					"isMany": true,
					"xml": {
						"serialize": "property"
					}
				},
				{
					"name": "expression",
					"type": "String",
					"isReference": true,
					"xml": {
						"serialize": "property"
					}
				}
			]
		}
	],
	"emumerations": [
		{
			"name": "AssociationDirection",
			"literalValues": [
				{
					"name": "None"
				},
				{
					"name": "One"
				},
				{
					"name": "Both"
				}
			]
		},
		{
			"name": "HitPolicy",
			"literalValues": [
				{
					"name": "UNIQUE"
				},
				{
					"name": "FIRST"
				},
				{
					"name": "PRIORITY"
				},
				{
					"name": "ANY"
				},
				{
					"name": "COLLECT"
				},
				{
					"name": "RULE ORDER"
				},
				{
					"name": "OUTPUT ORDER"
				}
			]
		},
		{
			"name": "BuiltinAggregator",
			"literalValues": [
				{
					"name": "SUM"
				},
				{
					"name": "COUNT"
				},
				{
					"name": "MIN"
				},
				{
					"name": "MAX"
				}
			]
		},
		{
			"name": "DecisionTableOrientation",
			"literalValues": [
				{
					"name": "Rule-as-Row"
				},
				{
					"name": "Rule-as-Column"
				},
				{
					"name": "CrossTable"
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/dmn-moddle/resources/dmn/json/dmn.json
// module id = 1141
// module chunks = 1